import React, { FC } from 'react';
import { shouldDisplayPaymentMethodUpdateRequiredAlert } from './helpers';
import { useBookingListContext } from '../contextProvider/BookingListContextProvider';
import { PaymentMethodUpdateRequired } from '../Alerts/PaymentMethodUpdateRequired';

const BookingListAlert: FC = () => {
  const { filter, bookings } = useBookingListContext();
  return shouldDisplayPaymentMethodUpdateRequiredAlert({ filter, bookings }) ? <PaymentMethodUpdateRequired /> : null;
};

export default BookingListAlert;
